import {EventEmitter, Inject, Injectable, Output} from '@angular/core';
import {Route} from './model/route.model';
import {Stop} from './model/stop.model';
import {LOCAL_STORAGE, StorageService} from 'angular-webstorage-service';
import {UUID} from 'angular2-uuid';
import {Point} from './model/point.model';
import {TrackVehicle} from './model/track-vehicle.model';
import {RouteColor} from './model/routecolor.model';
import {HereMapConverter} from './model/here-map-converter';
import {HttpClient} from '@angular/common/http';
import {RouteShape} from './model/routeshape.model';
import {map} from 'rxjs/operators';

export function getRandomColor(): string {
  return '#000000'.replace(/0/g, function () {
    return (~~(Math.random() * 16)).toString(16);
  });
}

export function getColorFromInput(str: string): string {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash += Math.pow(str.charCodeAt(i) * 31, str.length - i);
    hash = hash & hash; // Convert to 32bit integer
  }
  return 'hsl(' + (Math.pow(hash, 4)) % 360 + ', 100%, 75%)';
}

export function validRoute(route: string, provider: string): boolean {
  if (route !== null && route.toUpperCase().localeCompare('ALL') === 0) {
    return true;
  }

  // todo: confirm input is a valid route
  return VALID_ROUTES[provider] != null && VALID_ROUTES[provider].indexOf(route) !== -1;
}


export function getProvider(provider: string): string {
  // todo: confirm input is a valid route
  if (provider !== null && provider !== undefined) {
    provider = provider.toUpperCase();
    if (NJT_BUS.indexOf(provider) >= 0) {
      provider = 'NJT_BUS';
    }
    if (PATH.indexOf(provider) >= 0) {
      provider = 'PATH';
    }
    if (MTA_SUBWAY.indexOf(provider) >= 0) {
      provider = 'MTA_SUBWAY';
    }
    if (MTA_METRONORTH.indexOf(provider) >= 0) {
      provider = 'MTA_METRONORTH';
    }

    if (VALID_ROUTES[provider] !== null && VALID_ROUTES[provider] !== undefined) {
      return provider;
    }
  }
  return null;
}

const NJT_BUS = ['NJT', 'NJTRANSIT', 'NJT_BUS', 'NJTRANSIT_BUS', 'NJTRANSITBUS'];
const PATH = ['PATH'];
const MTA_SUBWAY = ['MTA', 'MTA_SUBWAY', 'SUBWAY'];
const MTA_METRONORTH = ['MNR', 'METRONORTH', 'MTA_METRONORTH'];

const VALID_ROUTES = {
  'NJT_BUS':
    ['1', '2', '5', '6', '10', '11', '13', '21', '22', '23', '25', '26', '27', '28', '29', '30', '34', '34S', '37', '39', '40', '41', '48', '52', '56', '57', '58', '59', '62', '63', '64', '65', '66', '67', '68', '70', '71', '72', '73', '74', '76', '78', '79', '80', '81', '82', '83', '84', '85', '86', '87', '88', '89', '90', '92', '94', '96', '97', '99', '107', '108', '111', '112', '113', '114', '115', '116', '117', '119', '120', '121', '122', '123', '124', '125', '126', '127', '128', '129', '130', '131', '132', '133', '135', '136', '137', '138', '139', '144', '145', '148', '151', '153', '154', '155', '156', '157', '158', '159', '160', '161', '162', '163', '163S', '164', '165', '166', '167', '168', '171', '175', '177', '178', '181', '182', '186', '188', '190', '191', '192', '193', '194', '195', '196', '197', '198', '199', '313', '315', '317', '319', '320', '321', '324', '329', '340', '361', '375', '378', '400', '401', '402', '403', '404', '405', '406', '407', '408', '409', '410', '412', '413', '414', '417', '418', '419', '450', '451', '452', '453', '455', '457', '459', '463', '468', '501', '502', '504', '505', '507', '508', '509', '551', '552', '553', '554', '555', '559', '600', '601', '603', '605', '606', '607', '608', '609', '610', '611', '612', '613', '619', '624', '702', '703', '704', '705', '707', '709', '712', '722', '744', '746', '748', '751', '752', '753', '755', '756', '758', '762', '770', '772', '780', '801', '802', '803', '804', '805', '810', '811', '813', '814', '815', '817', '818', '819', '822', '830', '831', '832', '834', '836', '837', '838', '871', '872', '873', '874', '875', '878', '880', '890', '891', '986', 'AC1', 'AC2A', 'AC3', 'AC4A', 'AC4B', 'AC5', 'GO25', 'GO28']
  ,
  'PATH': ['JSQ-33rd St', 'NWK-WTC', 'HOB-33', 'HOB-WTC', 'JSQ-33 (via HOB)'],
  'MTA_SUBWAY': ['1', '2', '3', '4', '5', '6', '7', 'A', 'B', 'C', 'D', 'E', 'F', 'N', 'Q', 'R', 'W'],
  'NJT_LR': ['HBLR', 'NEWARKLR', 'RIVERLINELR'],
  'NJT_TRAIN': ['GL', 'M&E', 'MAIN', 'MNBTN', 'NEC', 'NJCL', 'PASC', 'PRIN', 'RARV'],
  'MTA_METRONORTH': ['Danbury', 'Harlem', 'Hudson', 'New Canaan', 'New Haven', 'Waterbury']
};

const STORAGE_KEY_EXPERIMENTAL = 'local_experimental';
const STORAGE_KEY_ROUTES = 'local_routes';
const STORAGE_KEY_STOPS = 'local_stops';
const STORAGE_KEY_HIDE_ALL_STOPS = 'local_hide_all_stops';
const STORAGE_KEY_ZOOM_LEVEL = 'zoom_level';
const STORAGE_KEY_ICON_SIZE = 'local_icon_size';
const STORAGE_KEY_STOP_ID = 'local_stop_id';
const STORAGE_KEY_STOP_ID_PROVIDER = 'local_stop_id_provider';
const STORAGE_KEY_STOP_ID_ROUTE = 'local_stop_id_route';
const STORAGE_KEY_IDENTIFIER = 'local_identifier';
const STORAGE_KEY_ZOOM_IN = 'local_zoom_in';
const STORAGE_KEY_COLOR = 'local_color';
const STORAGE_KEY_SHAPE = 'local_shape';

@Injectable({
  providedIn: 'root'
})
export class SettingsDataService {
  experimental: boolean;
  routes: Route[];
  stops: Stop[];
  zoomLevel: number;
  iconSize: number;
  stopId: string;
  stopIdProvider: string;
  stopIdRoute: string;
  identifier: string;

  timestamp: number;
  zoomIn: number;

  routeColor: RouteColor[];
  routeShape: RouteShape[];

  @Output() routeAdded: EventEmitter<any>;
  @Output() routeRemoved: EventEmitter<Route>;
  @Output() routeModified: EventEmitter<Route>;
  @Output() minZoomLevelModified: EventEmitter<number>;
  @Output() iconSizeModified: EventEmitter<number>;
  @Output() stopIdRefresh: EventEmitter<boolean>;
  @Output() refreshAll: EventEmitter<any>;
  @Output() stopsModified: EventEmitter<any>;
  @Output() moveMapToPoint: EventEmitter<Point>;
  @Output() trackVehicle: EventEmitter<TrackVehicle>;


  @Output() activityDetected: EventEmitter<string>;
  ne;

  constructor(@Inject(LOCAL_STORAGE) private storage: StorageService, public http: HttpClient) {
    this.experimental = this.storage.get(STORAGE_KEY_EXPERIMENTAL) || false;
    this.routes = this.storage.get(STORAGE_KEY_ROUTES) || [];
    this.zoomLevel = this.storage.get(STORAGE_KEY_ZOOM_LEVEL) || 15;
    this.iconSize = this.storage.get(STORAGE_KEY_ICON_SIZE) || 2.3;
    this.stopId = this.storage.get(STORAGE_KEY_STOP_ID) || null;
    this.stopIdProvider = this.storage.get(STORAGE_KEY_STOP_ID_PROVIDER) || null;
    this.stopIdRoute = this.storage.get(STORAGE_KEY_STOP_ID_ROUTE) || 'ALL';
    this.identifier = this.storage.get(STORAGE_KEY_IDENTIFIER) || UUID.UUID();
    this.zoomIn = this.storage.get(STORAGE_KEY_ZOOM_IN) || 0;
    this.routeColor = this.storage.get(STORAGE_KEY_COLOR) || [];
    this.routeShape = this.storage.get(STORAGE_KEY_SHAPE) || [];

    this.storage.set(STORAGE_KEY_IDENTIFIER, this.identifier);

    this.routeAdded = new EventEmitter();
    this.routeRemoved = new EventEmitter();
    this.routeModified = new EventEmitter();
    this.minZoomLevelModified = new EventEmitter<number>();
    this.iconSizeModified = new EventEmitter<number>();
    this.stopIdRefresh = new EventEmitter<boolean>();
    this.refreshAll = new EventEmitter<any>();
    this.stopsModified = new EventEmitter<any>();
    this.moveMapToPoint = new EventEmitter<Point>();
    this.activityDetected = new EventEmitter<any>();
    this.trackVehicle = new EventEmitter<TrackVehicle>();

    this.routeAdded.subscribe(route => this.routeModified.emit(route));
    this.routeRemoved.subscribe(route => this.routeModified.emit(route));

    this.routes.sort((a: Route, b: Route) => HereMapConverter.compareFn(a, b));


    this.stops = [];
    const savedstops = this.storage.get(STORAGE_KEY_STOPS) || [];
    savedstops.forEach(s => {
      const convertedStop = new Stop();
      convertedStop.lat = s.lat;
      convertedStop.lon = s.lon;
      convertedStop.stopDescription = s.stopDescription;
      convertedStop.providerId = s.providerId;
      convertedStop.stopId = s.stopId;
      convertedStop.route = s.route;
      this.stops.push(convertedStop);
    });


    this.timestamp = new Date().getTime();
    this.activityDetected.subscribe(any => {
      this.timestamp = new Date().getTime();
    });
  }

  addResolvedRoute(route: Route): boolean {
    let duplicate: boolean;
    duplicate = false;

    this.routes.forEach(value => {
      duplicate = duplicate || HereMapConverter.equalsRoute(value, route);
    });

    if (!duplicate) {
      // save to storage
      this.routes.push(route);
      this.routes.sort((a: Route, b: Route) => HereMapConverter.compareFn(a, b));

      this.storage.set(STORAGE_KEY_ROUTES, this.routes);

      this.routeAdded.emit(route);
      return true;
    }
    return false;
  }

  addRoute(route: string, provider: string): boolean {
    let found = false;
    route.split(',').forEach(r => {

      if (!validRoute(r, provider)) {
        return false;
      }

      const newRoute = new Route(provider, provider, r.trim(), r.trim(), this.getColor(r.trim()));
      found = found || this.addResolvedRoute(newRoute);
    });
    return found;

  }

  removeRoute(route: Route) {
    let index = -1;
    for (let i = 0, len = this.routes.length; i < len; i++) {
      if (HereMapConverter.equalsRoute(route, this.routes[i])) {
        index = i;
        break;
      }
    }
    if (index !== -1) {
      this.routes.splice(index, 1);

      this.storage.set(STORAGE_KEY_ROUTES, this.routes);
      this.routeRemoved.emit(route);
    }

    index = -1;

    for (let i = 0, len = this.routeColor.length; i < len; i++) {
      if (route.routeId.localeCompare(this.routeColor[i].route) === 0) {
        index = i;
        break;
      }
    }
    if (index !== -1) {
      this.routeColor.splice(index, 1);
      this.storage.set(STORAGE_KEY_COLOR, this.routeColor);
    }

  }

  minZoomLevel(minZoomLevel: number) {
    this.zoomLevel = minZoomLevel;
    this.storage.set(STORAGE_KEY_ZOOM_LEVEL, this.zoomLevel);
    this.minZoomLevelModified.emit(this.zoomLevel);
  }

  changeIconSize(iconSize: number) {
    if (iconSize >= 10) {
      iconSize = 10;
    }

    if (iconSize < 0.1) {
      iconSize = 0.1;
    }


    this.iconSize = iconSize;
    this.storage.set(STORAGE_KEY_ICON_SIZE, this.iconSize);
    this.iconSizeModified.emit(this.iconSize);
  }

  updateStopID(stopId: string, stopIdProvider: string, route: string) {
    this.stopId = stopId;
    this.stopIdProvider = stopIdProvider;
    this.storage.set(STORAGE_KEY_STOP_ID, this.stopId);
    this.storage.set(STORAGE_KEY_STOP_ID_PROVIDER, this.stopIdProvider);

    this.stops.forEach(stop => {
      if (stop.providerId === this.stopIdProvider && stop.stopId === this.stopId) {
        route = stop.route;

      }
    });

    this.updateStopIDRoute(route, true);
  }

  updateStopIDRoute(route: string, updateUrl: boolean) {
    if (route === null || route === undefined || route.trim().length === 0) {
      route = 'ALL';
    }
    this.stopIdRoute = route;
    this.storage.set(STORAGE_KEY_STOP_ID_ROUTE, this.stopIdRoute);

    let changed = false;
    this.stops.forEach(stop => {
      if (stop.providerId === this.stopIdProvider && stop.stopId === this.stopId) {
        stop.route = route;
        changed = true;
      }
    });
    if (changed) {
      this.storage.set(STORAGE_KEY_STOPS, this.stops);
    }
    this.stopIdRefresh.emit(updateUrl);
  }

  getValidRoutes(provider: string): string [] {
    const routes = VALID_ROUTES[provider];
    if (routes !== null && routes !== undefined) {
      return routes;
    }
    return VALID_ROUTES['NJT_BUS'];
  }

  getValidProviders(): string [] {
    return ['NJT_BUS', 'NJT_LR', 'NJT_TRAIN', 'PATH', 'MTA_SUBWAY', 'MTA_METRONORTH'];
  }

  toggleExperimental() {
    this.experimental = !this.experimental;
    this.storage.set(STORAGE_KEY_EXPERIMENTAL, this.experimental);
  }

  getSavedRoutes(provider: string): Route[] {
    const result: Route[] = [];

    this.routes.forEach(route => {
      if (route.providerId === provider) {
        result.push(route);
      }

    });
    return result;
  }

  getSavedStops(provider: string): Stop[] {
    const result: Stop[] = [];

    this.stops.forEach(stop => {
      if (stop.providerId === provider) {
        result.push(stop);
      }

    });
    return result;
  }

  updatePinnedStop(stop: Stop, pinned: boolean) {
    if (pinned) {
      // add
      let duplicate = false;
      this.stops.forEach(s => {
        if (HereMapConverter.equals(s, stop)) {
          duplicate = true;
        }
      });
      if (!duplicate) {
        this.stops.push(stop);

        this.storage.set(STORAGE_KEY_STOPS, this.stops);
        this.stopsModified.emit();
      }

    } else {
      // remove
      let index = -1;
      for (let i = 0, len = this.stops.length; i < len; i++) {
        if (HereMapConverter.equals(stop, this.stops[i])) {
          index = i;
          break;
        }
      }
      if (index !== -1) {
        this.stops.splice(index, 1);

        this.storage.set(STORAGE_KEY_STOPS, this.stops);
        this.stopsModified.emit();
      }

    }
  }

  isPinned(stopId: string, stopIdProvider: string): boolean {
    let found = false;
    this.stops.forEach(s => {
      if (HereMapConverter.matches(s, stopIdProvider, stopId)) {
        found = true;
      }
    });
    return found;
  }

  noRecentActivity(): boolean {
    if ((this.timestamp + 1000 * 60 * 15) < new Date().getTime()) {
      return true;
    }
    return false;
  }

  shouldZoom(): boolean {
    this.zoomIn++;
    this.storage.set(STORAGE_KEY_ZOOM_IN, this.zoomIn);
    if (this.zoomIn > 3) {
      return false;
    }
    return true;
  }


  getColor(routeId: string) {
    for (let index = 0; index < this.routes.length; index++) {
      if (this.routes[index].routeId.localeCompare(routeId) === 0) {
        if (this.routes[index].color.indexOf('hsr') < 0) {
          this.routes[index].color = getColorFromInput(routeId);
          this.storage.set(STORAGE_KEY_ROUTES, this.routes);
        }
        return this.routes[index].color;
      }
    }
    let color: string = null;
    this.routeColor.forEach(route => {
      if (route.route !== null && route.route.localeCompare(routeId) === 0) {
        if (route.color.indexOf('hsr') < 0) {
          route.color = getColorFromInput(routeId);
        }
        color = route.color;
      }
    });
    if (color !== null) {
      this.storage.set(STORAGE_KEY_COLOR, this.routeColor);
      return color;
    }

    color = getColorFromInput(routeId);
    this.routeColor.push(new RouteColor(routeId, color));
    this.storage.set(STORAGE_KEY_COLOR, this.routeColor);

    return color;
  }

  getRouteShape(providerId: string, routeId: string): RouteShape {
    let result: RouteShape = null;

    this.routeShape.forEach(rs => {
      if (rs.providerId.localeCompare(providerId) === 0 && rs.routeId.localeCompare(routeId) === 0) {
        result = rs;
      }
    });

    if (result !== null && result !== undefined) {
      return result;
    }
    // need to lookup

    this.http.get(`https://ShowMeMyCommute.com:5928/getRouteShape?providerId=${providerId}&routeId=${routeId}`)
      .pipe(map(res => new RouteShape().deserialize(res)))
      .subscribe(res => {

        const newRouteShape = new RouteShape();
        newRouteShape.deserialize(res);
        newRouteShape.providerId = providerId;
        newRouteShape.routeId = routeId;

        let found = false;
        this.routeShape.forEach(rs => {
          if (rs.providerId.localeCompare(providerId) === 0 && rs.routeId.localeCompare(routeId) === 0) {
            found = true;
          }
        });
        console.log('new shape');
        if (!found) {
          this.routeShape.push(newRouteShape);
          this.storage.set(STORAGE_KEY_SHAPE, this.routeShape);
        }


        this.routeAdded.emit(true);
      });


    return null;
  }

  getCount(): number {
    return this.routes.length;
  }
}
